import { Typography } from 'seagull';
import styles from "./MapContactsModal.module.scss";
import { getContactMapStatus } from "./MapContactsRow";
import { orderBy, sortBy } from 'lodash-es';
import { getAccountingDetails } from "../accounting.utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export let ContentState = /*#__PURE__*/function (ContentState) {
  ContentState["Loading"] = "loading";
  ContentState["Empty"] = "empty";
  ContentState["Error"] = "error";
  ContentState["Valid"] = "valid";
  return ContentState;
}({});
export let FooterState = /*#__PURE__*/function (FooterState) {
  FooterState["Valid"] = "valid";
  FooterState["Invalid"] = "invalid";
  return FooterState;
}({});
export const columnDefs = [{
  width: 400
},
// Anchor contacts
{
  width: 400
},
// Accounting Online customers
{
  width: [200, 260]
} // Status
];
export const getHeaderItems = accounting => [{
  value: /*#__PURE__*/_jsx("div", {
    className: styles.columnHeader,
    children: /*#__PURE__*/_jsx(Typography, {
      variant: "paragraph2",
      children: "Anchor contact"
    })
  })
}, {
  value: /*#__PURE__*/_jsx("div", {
    className: styles.columnHeader,
    children: /*#__PURE__*/_jsxs(Typography, {
      variant: "paragraph2",
      children: [getAccountingDetails(accounting).fullName, " customer"]
    })
  })
}, {
  value: 'Status'
}];
export let AccountingCustomersDropdownOptionType = /*#__PURE__*/function (AccountingCustomersDropdownOptionType) {
  AccountingCustomersDropdownOptionType["CreateNew"] = "createNew";
  AccountingCustomersDropdownOptionType["Existing"] = "existing";
  return AccountingCustomersDropdownOptionType;
}({});
export let FailureReasons = /*#__PURE__*/function (FailureReasons) {
  FailureReasons["General"] = "general";
  FailureReasons["DuplicateMapping"] = "duplicateMapping";
  FailureReasons["DuplicateNew"] = "duplicateNew";
  return FailureReasons;
}({});
export function getModalState(contacts, accountingCustomers) {
  if (contacts.error || accountingCustomers.error) {
    return {
      content: ContentState.Error,
      footer: FooterState.Invalid
    };
  } else if (!contacts.data && contacts.loading || !accountingCustomers.data && accountingCustomers.loading) {
    return {
      content: ContentState.Loading,
      footer: FooterState.Invalid
    };
  } else if (contacts.data && accountingCustomers.data) {
    return contacts.data.length === 0 ? {
      content: ContentState.Empty,
      footer: FooterState.Invalid
    } : {
      content: ContentState.Valid,
      footer: FooterState.Valid
    };
  } else {
    return {
      content: ContentState.Loading,
      footer: FooterState.Invalid
    };
  }
}
export function getNumMappedContacts(contacts, accounting) {
  return contacts.filter(c => !!c.integratedId({
    accounting
  })).length;
}
export function getRelevantSortedContacts(contacts, contactIds, accounting) {
  if (!contacts) {
    return [];
  }
  const filtered = contacts.filter(c => (!contactIds.length || contactIds.includes(c.id())) && !c.isSample());
  const orderedByName = orderBy(filtered, [c => c.firstName(), c => c.lastName(), c => c.companyName()], ['asc', 'asc', 'asc']);
  return sortBy(orderedByName, c => !!c.integratedId({
    accounting
  }));
}
export function applyFilters(contacts, search, contactMappingStatusFilter, accounting) {
  const searchFiltered = contacts.filter(c => applySearch(search, c));
  const contactMappingStatusFilterOptions = getContactMappingStatusFilterOptions(searchFiltered, accounting);
  const filteredAnchorContacts = searchFiltered.filter(c => applyContactMappingStatusFilter(contactMappingStatusFilter, c, accounting));
  return {
    filteredAnchorContacts,
    contactMappingStatusFilterOptions
  };
}
function getContactMappingStatusFilterOptions(contacts, accounting) {
  return contacts.reduce((acc, contact) => {
    const status = getContactMapStatus(contact, accounting);
    const existingStatusEntry = acc.findIndex(option => option.value === status);
    if (existingStatusEntry >= 0) {
      acc[existingStatusEntry].counter = (acc[existingStatusEntry].counter || 0) + 1;
    } else {
      acc.push({
        value: status,
        counter: 1,
        label: status === 'mapped' ? 'Yes' : 'No'
      });
    }
    return acc;
  }, []);
}
function applySearch(search, contact) {
  const normalizedSearch = search ? search.trim().toLowerCase() : search;
  const companyName = contact.companyName().toLowerCase();
  const firstName = contact.firstName().toLowerCase();
  const lastName = contact.lastName().toLowerCase();
  const email = contact.email().toLowerCase();
  return !normalizedSearch || "".concat(companyName, " ").concat(firstName, " ").concat(lastName, " ").concat(email).includes(normalizedSearch);
}
function applyContactMappingStatusFilter(filter, contact, accounting) {
  return filter.length === 0 || filter.some(status => status === 'mapped' && contact.integratedId({
    accounting
  }) != null || status === 'notMapped' && contact.integratedId({
    accounting
  }) == null);
}